import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./FAQ.css";
import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";
import telegramIcon from '../../../../assets/images/telegramIcon.svg'
import whiteArrowIcon from '../../../../assets/images/Home/whiteArrow.svg'
import { Link } from "react-router-dom";
import useLangLink from "../../../../utils/useLangLink";
import SEO from "../../../../utils/SEO";


export default function FAQ() {
    const { t } = useTranslation();
    const lp = useLangLink();
    const tp = (k, d) => t(`pages.faq.${k}`, d);
    const [openIndex, setOpenIndex] = useState(null);

    const [isMobileToogle, setIsMobileToogle] = useState(false)

    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobileToogle(window.innerWidth <= 500);
        } 

        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        
        return () => window.removeEventListener('resize', checkIfMobile);
    }, [])

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqSections = tp('sections', { returnObjects: true }) || [];

    return (
        <main className='main'>

            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/faq"
            />

            <section className='section'>
               {!isMobileToogle ? (
                    <BreadCrumbs
                        data={[
                            {
                                name: 'Offshore Advisory',
                                link: '/',
                            },
                            {
                                name: tp('breadcrumb.self'),
                                link: '/faq',
                            },
                        ]}
                    />
                ) : null}
                
                <div className="faq-container container">
                    <div className="faq-content">
                        <div className="faq-header">
                            <div className="faq-badge">
                                <BreadCrumbs
                                    data={[
                                        {
                                            name: 'Offshore Advisory',
                                            link: '/',
                                        },
                                        {
                                            name: tp('breadcrumb.self'),
                                            link: '/faq',
                                        },
                                    ]}
                                />  
                                </div>
                            <h1 className="faq-title">{tp('title')}</h1>
                            <p className="faq-subtitle">
                                {tp('subtitle')}
                            </p>
                            <p className="faq-description">
                                {tp('description')}
                            </p>
                            <Link to={lp('/newsletter')} className="btn-shareit">
                                {tp('shareIt')}
                                <img src={telegramIcon} alt="Telegram" />
                            </Link>
                        </div>

                        {faqSections.map((section, sIdx) => (
                            <div key={sIdx} className="faq-section">
                                <h2 className="faq-section-title">{section.title}</h2>
                                <div className="faq-list">
                                    {section.items.map((item, iIdx) => {
                                        const globalIndex = `${sIdx}-${iIdx}`;
                                        const isOpen = openIndex === globalIndex;

                                        return (
                                            <div key={iIdx} className={`faq-item ${isOpen ? "open" : ""}`}>
                                                <button
                                                    className={`faq-question ${isOpen ? "open" : ""}`}
                                                    onClick={() => toggleFAQ(globalIndex)}
                                                    aria-expanded={isOpen}
                                                >
                                                    <span className="faq-question-text">{item.q}</span>
                                                    <span className={`faq-icon ${isOpen ? "open" : ""}`}>
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="chevron-svg"
                                                        >
                                                            <path
                                                                d="M6 9L12 15L18 9"
                                                                stroke="currentColor"
                                                                strokeWidth="2.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                               </button>
                                                <div className={`faq-answer-wrapper ${isOpen ? "open" : ""}`}>
                                                    <div className="faq-answer-inner">
                                                        <div
                                                            className="faq-answer"
                                                            dangerouslySetInnerHTML={{
                                                                __html: /^\s*</.test(item.a) ? item.a : `<p>${item.a}</p>`,
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                        
                       
                    </div>
                </div>
                        <div className="still-question-background">
                            <div className="still-question-content">
                                <h2 className="still-question-title">
                                    {tp('still.title')}
                                </h2>
                                <p className="still-question-descr">
                                    {tp('still.descr')}
                                </p>
                                <Link to={lp('/newsletter')} className="still-question-btn">
                                    {tp('still.button')}
                                    <img src={whiteArrowIcon} alt="" />
                                </Link>
                            </div>
                        </div>
            </section>
            {/* <Footer /> */}
        </main>
    );
}
